export const namespace = 'webSettings'
